<template>
  <div class="p-4">
    <OrderCard
        v-for="order in orders"
        :key="order.id"
        :order="order"/>

  </div>
</template>

<script>
import {getOrders} from "@/API/API";
import OrderCard from "@/components/User/OrderCard";

export default {
  name: "OrderPage",
  components: {OrderCard},
  data() {
    return {
      orders: []
    }
  },
  async created() {
    this.orders = (await getOrders()).data
  }
}
</script>

<style scoped>

</style>